import {ConfigService} from 'shared';
import {ModelsList, StoreService} from 'shared';
import {Observable} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ErrorsService, Field} from 'shared';

@Injectable({
  deps: [HttpClient],
  providedIn: 'root'
})
export class FieldService extends StoreService<Field> {

  constructor(http: HttpClient, config: ConfigService, errors: ErrorsService) {
    super(http, config, errors);
    this.initStore(Field);
  }

  load(queryParams?: HttpParams): Observable<ModelsList<Field>> {
    return this.http.get<ModelsList<Field>>(this.config.apiVerUrl('/app/fields'), {params: queryParams});
  }

  insert(values: Field): Observable<number> {
    return this.http.post<number>(this.config.apiVerUrl('/app/fields'), values);
  }

  remove(id): Observable<void> {
    return this.http.delete<void>(this.config.apiVerUrl(`/app/fields/${id}`));
  }

  update(id, values: Field): Observable<Field> {
    return this.http.put<Field>(this.config.apiVerUrl(`/app/fields/${id}`), values);
  }

  public massFileInsert(values): Observable<number> {
    return this.http.post<number>(this.config.apiVerUrl('/app/fields/mass-upload'), values);
  }

  toKML(id) {
    return this.http.get(this.config.apiVerUrl(`/app/fields/${id}/to-kml`), {
      responseType: 'text',
    });
  }

  toMassKML(ids: number[]) {
    return this.http.post(this.config.apiVerUrl(`/app/fields/to-mass-kml`), ids, {
      responseType: 'text',
    });
  }

  trailerInterventionsReport(id, from, to, operationTypes) {
    return this.http.post(this.config.apiVerUrl(`/app/fields/${id}/trailer-interventions-report`), {
      id, from, to, operationTypes
    });
  }

  public checkCode(code: string, id?: number): Observable<boolean> {
    return this.http.post<boolean>(this.config.apiVerUrl('/app/fields/check-code'), {code, id});
  }
}
